import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Footer, Landing, About, Skills, Testimonials, Blog, Education, Experience, Contacts, Projects, Services, Achievement } from '../../components'
import { headerData } from '../../data/headerData'

function Main(props) {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Sarl</title>
            </Helmet>

            <Navbar />        
            <Landing userData={props.userData} />
            <About about={props.userData["LongueDescription"]} />
				 
            <Skills competences={props.userData.competences} />
			<Services description={props.userData.ServiceDescription} services={props.userData.services} />
			<Projects projets={props.userData.projects}/>
		    <Education  valeurs={props.userData.valeurs}/>
            <Experience experiences={props.userData.points_forts}/> 
            <Achievement certifications={props.userData.certifications}/>
			<Testimonials temoignages={props.userData.temoignages} />
           
            <Contacts userData={props.userData} />
            <Footer />
        </div>
    )
}

export default Main
